import { FlocosProductionStatus, Perfil, Permission, ProductionKey } from 'src/constants';
import { ProcessingKey } from 'src/constants/ProcessingKey';

export enum TotalsAdmin {
  PENDENCIAS_PRODUCAO = 'pending_production',
  PENDENCIAS_BENEFICIAMENTO = 'pending_processing',
  TOTALS_PRODUCED = 'totals_produced',
  USAGE = 'usage',
}

export const getTotalsAdminLabel = (key: TotalsAdmin) => {
  switch (key) {
    case TotalsAdmin.PENDENCIAS_PRODUCAO:
      return 'Pendências na produção de óleo, azeite e flocos';
    case TotalsAdmin.PENDENCIAS_BENEFICIAMENTO:
      return 'Pendências na revisão e processamento do mesocarpo';
    case TotalsAdmin.TOTALS_PRODUCED:
      return 'Produções e processamentos concluídos';
    case TotalsAdmin.USAGE:
      return 'Informações de uso';
  }
};

export enum UsageTypes {
  USUARIA = 'perfil',
  ENTREPOSTO = 'entreposto',
  GRUPO = 'grupo',
  USUARIA_QUEBRADEIRA = `perfil_${Perfil.QUEBRADEIRA}`,
  USUARIA_ENTREPOSTO = `perfil_${Perfil.ENTREPOSTO}`,
  ASSOCIADA_ASMUBIP = Permission.ASSOCIADA_ASMUBIP,
}

export const getUsageTypesLabel = (key: UsageTypes) => {
  switch (key) {
    case UsageTypes.USUARIA:
      return 'Usuárias(os)';
    case UsageTypes.ENTREPOSTO:
      return 'Entrepostos';
    case UsageTypes.GRUPO:
      return 'Grupos e Núcleos';
    case UsageTypes.USUARIA_QUEBRADEIRA:
      return 'Quebradeiras e Familiares';
    case UsageTypes.USUARIA_ENTREPOSTO:
      return 'Integrantes dos entrepostos';
    case UsageTypes.ASSOCIADA_ASMUBIP:
      return 'Filiadas à ASMUBIP';
  }
};

export type TotalsAdminPendingProduction = Record<ProductionKey, string[]>;
export type TotalsAdminPendingProcessing = Record<
  Exclude<
    FlocosProductionStatus,
    FlocosProductionStatus.IN_PRODUCTION | FlocosProductionStatus.COMPLETE
  >,
  number
>;
export type TotalsAdminProduction = Record<ProductionKey & ProcessingKey, number>;
export type TotalsAdminUsage = Record<UsageTypes, number>;

export type HomeTotalsAdminType = {
  [TotalsAdmin.PENDENCIAS_PRODUCAO]: TotalsAdminPendingProduction;
  [TotalsAdmin.PENDENCIAS_BENEFICIAMENTO]: TotalsAdminPendingProcessing;
  [TotalsAdmin.TOTALS_PRODUCED]: TotalsAdminProduction;
  [TotalsAdmin.USAGE]: TotalsAdminUsage;
};

// II - Pendências nos grupos
// 1. Azeite em produção
// 2. Óleo em produção
// 3. Flocos em produção

// II - Pendências no Entreposto
// 1. Flocos a revisar
// 2. Flocos revisados e não beneficiados

// III - Produção
// 1. produção de mesocarpo
// 2. produção de azeite
// 3. produção de óleo
// 4. produção de flocos

// IV - Uso
// 1. usuárias
// 2. entrepostos
// 3. grupos
// 4. quebradeiras
